import { buildPrompt } from '@/ai/utils/promptBuilder'
import { examples } from '@/ai/prompts/common/examples'
import { systemMessages } from '@/ai/prompts/common/systemMessages'
import { getAggregateName, getCommandName } from '@/ai/utils/helpers'
import { getJsonOutputFormatting } from '@/ai/prompts/common/formatting'
import {
  diagramToJson,
  createUserMessage,
  createSystemMessage,
  getWorkflowBackgroundSections
} from '@/ai/utils/promptUtils'

export const buildWriteModelPrompt = ({ eventId, workflow, svgGraph, svgLanes, cardTypes }) => {
  const messages = []

  messages.push(createSystemMessage(systemMessages.EVENT_MODELING_DDD_EXPERT))

  const promptSections = []

  const { workflow: currentDiagram, currentStep } = workflow.eventsJson?.length
    ? diagramToJson(eventId, workflow, svgGraph, svgLanes)
    : { workflow: [], currentStep: undefined }
  const currentStepObject = currentDiagram[currentStep - 1]
  const roleName = currentStepObject.role
  const description = currentStepObject.description
  const workflowBackgroundSections = getWorkflowBackgroundSections(workflow, currentDiagram, cardTypes)

  const commandName = getCommandName(currentStepObject, cardTypes)
  const aggregateName = getAggregateName(currentStepObject, cardTypes)

  promptSections.push(...workflowBackgroundSections)

  promptSections.push({
    title: 'Request',
    content: `
      Focus on step ${currentStep}: ${roleName} - ${description}. For this step in the process,
      create a set of input fields. You are designing a simple input form (or mockup or wireframe) with data
      fields to be filled in and submitted by the actor (or role), in order to invoke the command "${commandName}"
      on the aggregate "${aggregateName}", for this step of the process. Each data field is an input field that the user
      (or system, if automated) can fill in. The form reflects the information requested from the actor in order
      to invoke the command on the aggregate. The number of input fields per step can vary, but it is
      usually between 4 and 8. A data field name must be at most 30 characters long.
    `
  })

  const writeModelExample = { writeModel: examples.commandExampleCreateOrder }

  promptSections.push({
    title: 'Formatting',
    flattenLines: false,
    content: getJsonOutputFormatting('writeModel', JSON.stringify(writeModelExample))
  })

  const userContent = buildPrompt(promptSections)
  messages.push(createUserMessage(userContent))

  return messages
}
